import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiUrl,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  ({ response }) => {
    if (response.data) {
      if (Array.isArray(response.data.message)) {
        response.data.message = response.data.message.join(', ');
      }

      return Promise.reject(response.data);
    }

    return Promise.reject(response.data);
  }
);

export const axiosBaseQuery =
  () =>
  async ({ url, method, data, params, headers }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data,
        params,
        headers,
      });
      return { data: result?.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };
export default axiosInstance;
